module.exports = __webpack_public_path__ + "static/ANNA_DELLA_PINA-37b2241b8b8d82dd316e962db90e9fef.jpg";